import React from "react";
import { Form } from "react-bootstrap";
import { TGridLegsOption, TGridOption } from "../../../../../api/endpoints/SubsetOption";
import Footnote from "../../../Footnote";
import FormError from "../../../FormError";
import GridSelector from "../../../GridSelector";
import { FormikProductFormField, TFormErrorMessage } from "../../index";

interface Props extends FormikProductFormField {
  spec: TGridLegsOption | TGridOption;
}

const GridField = (props: Props) => {
  const { formik, spec } = props;

  return (
    <Form.Group controlId="grid">
      <Form.Label>Resolution</Form.Label>
      <GridSelector
        values={formik.values.grid}
        spec={spec}
        onChange={values => formik.setFieldValue('grid', values)}
      />

      <FormError
        message={formik.errors.grid as TFormErrorMessage}
        when={formik.touched.grid && Boolean(formik.errors.grid)}
      />

      <Footnote text={spec.footnote} />
    </Form.Group>
  );
}

export default GridField;
